// /src/pages/ProfilePage.jsx
import React from 'react';
import { useAuth } from '../AuthContext';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './ProfilePage.css'; // Your CSS import is correct

export default function ProfilePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  // Applied loading-message class
  if (!user) return <p className="loading-message">Loading user info...</p>;

  return (
    // Applied profile-page-container class for main layout
    <div className="profile-page-container">
      <h2>Profile</h2>
      
      {/* Group profile information in profile-info-card */}
      <div className="profile-info-card">
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>UID:</strong> {user.uid}</p>
        {user.displayName && (
          <p><strong>Name:</strong> {user.displayName}</p>
        )}
      </div>

      {/* Group buttons in profile-buttons-group for consistent layout */}
      <div className="profile-buttons-group">
        <Link to="/dashboard" className="profile-button">Back to Dashboard</Link>
        <Link to="/subscription-management" className="profile-button manage-subscription-button">
          Manage Subscription
        </Link>
        <button onClick={handleLogout} className="profile-logout-button">Log Out</button>
      </div>
    </div>
  );
}